export default __webpack_public_path__ + "static/media/badge-cloud.4851a3a5.svg";